import React from 'react'
import connect from 'front-end-core/decorators/connect'
import { requestSearchResults } from 'services/SearchService'
import PagedSearchContainer from 'redux/containers/components/search/PagedSearchContainer'

const ConnectedPageSearch = connect(({ searchPhrase, searchType, pageNumber, pageLimit, aol, flavour, query }) => {
  return ({
    response: requestSearchResults({
      searchPhrase, searchType, pageNumber, pageLimit, aol, flavour, query
    })
  })
})(props => <PagedSearchContainer {...props} />)

export default ConnectedPageSearch
